<template>
    <form
        class="flex flex-col w-full h-full"
        @submit.prevent.stop="onSubmit"
    >
        <div class="py-2 container border-b inline-flex w-full">
            <i
                class="min-w-6 icon icon-close mr-4 my-2 cursor-pointer text-slate-400 hover:text-slate-600"
                @click="closeEditPopup"
            ></i>
            <UserAvatar
                :name="isNewIdentityUser ? user.username : avatar.name"
                :animated-avatar="post.postAnonymous ? null : user.gamify_avatar_url"
                :picture="isNewIdentityUser ? userPicture : avatar.picture"
                :is-anonymous="isNewIdentityAnonymous"
                :show-details="false"
                :show-admin-badge="isNewIdentityUser ? user.hasAdminBadge : avatar.hasAdminBadge"
                class="mr-2 h-10 w-10"
            ></UserAvatar>
            <span class="truncated leading-10 font-medium mr-auto">
                {{ title }}
            </span>
            <BtnCta
                data-testid="post-edit-form-mobile_btn-send"
                type="submit"
                icon="send"
                class="ml-2"
                size="sm"
                :disabled="isUpdating || isUploading"
            />
        </div>
        <textarea
            ref="text"
            v-model="post.text"
            :placeholder="$t('askQuestion')"
            class="bg-white w-full py-5 container"
        ></textarea>
        <PostPhotoUpload
            v-if="post.hasPhoto"
            class="flex-none p-4 mb-14 border-t w-full overflow-x-scroll md:overflow-x-auto md:px-20 md:mb-3"
            :files="photo.files"
            @delete="deletePhoto"
            @upload-start="isUploading = true"
            @upload-end="isUploading = false"
        ></PostPhotoUpload>
        <div
            :class="[
                'bg-white absolute left-0 bottom-0 w-full container py-4 inline-flex border-t',
                isAnonymityEnabled ? '' : 'justify-end',
            ]"
        >
            <Btn
                v-if="isAnonymityEnabled"
                variant="tonal"
                :class="['ml-auto mr-2', user?.is_premium ? 'text-slate-400' : 'text-purple-500']"
                :content-color="user?.is_premium ? 'slate-600' : 'purple-500'"
                active-color="blue-600"
                active-content-color="blue-600"
                icon="incognito"
                size="sm"
                :active="post.postAnonymous"
                color-on-touch
                @click.prevent.stop="toggle('postAnonymous')"
            />
            <Btn
                variant="tonal"
                class="mr-2 text-slate-400"
                content-color="slate-600"
                active-color="blue-600"
                active-content-color="blue-600"
                icon="camera"
                size="sm"
                :active="post.hasPhoto"
                color-on-touch
                @click.prevent.stop="toggle('hasPhoto')"
            />
        </div>
    </form>
</template>

<script>
import { mapGetters } from 'vuex';
import { BtnSize } from '@components/Btn';
import PostPhotoUpload from '@components/PostItem/PostPhotoUpload.vue';
import { featureIsEnabled } from '@/modules/features';
import PostEditForm from './PostEditForm.vue';

export default {
    name: 'PostEditFormMobile',
    i18nOptions: {
        namespaces: ['post'],
    },
    components: { PostPhotoUpload },
    extends: PostEditForm,
    data() {
        return {
            BtnSize,
        };
    },
    computed: {
        ...mapGetters('auth', ['user']),
        isAnonymityEnabled() {
            return featureIsEnabled('anonymityIdentity') && this.user?.is_premium_system_enabled;
        },
        title() {
            return this.isNewIdentityAnonymous
                ? this.$t('Post anonymously')
                : this.$t('Post as {name}', {
                      name: this.isNewIdentityUser ? this.user.username : this.avatar.name,
                  });
        },
    },
};
</script>

<style lang="scss" scoped>
textarea {
    @apply resize-none outline-none border-0;
    height: calc(100% - 9rem);
}

.photo {
    textarea {
        height: calc(100% - 16rem);
    }
}

.truncated {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
